(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tka-product"]) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.tkaReady) return;
      root.dataset.tkaReady = '1';
      const variants = JSON.parse(root.querySelector('[data-tka-variants]').textContent);
      const labels = JSON.parse(root.querySelector('[data-tka-labels]').textContent);
      const groups = [...root.querySelectorAll('[data-tka-option]')];
      const idInput = root.querySelector('[data-tka-id]');
      const price = root.querySelector('[data-tka-price]');
      const add = root.querySelector('[data-tka-add]');
      const ship = root.querySelector('[data-tka-ship]');
      const mtoProp = root.querySelector('[data-tka-mto-prop]');
      if (!groups.length) return;

      const selected = () =>
        groups.map((g) => g.querySelector('[aria-pressed="true"]')?.dataset.value ?? null);

      const update = () => {
        const sel = selected();
        const match = variants.find((v) => v.options.every((o, i) => o === sel[i]));
        groups.forEach((g, gi) => {
          g.querySelectorAll('button').forEach((b) => {
            const trial = sel.slice();
            trial[gi] = b.dataset.value;
            const ok = variants.some((v) => v.available && v.options.every((o, i) => o === trial[i]));
            b.classList.toggle('is-out', !ok);
          });
        });
        if (match) {
          idInput.value = match.id;
          price.textContent = match.price;
          add.disabled = !match.available;
          add.textContent = match.available ? labels.add : labels.soldOut;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
          if (ship) ship.textContent = match.mto ? labels.mto : labels.stock;
          if (mtoProp) mtoProp.disabled = !match.mto;
        } else {
          add.disabled = true;
          add.textContent = labels.unavailable;
        }
      };

      groups.forEach((g) => {
        g.addEventListener('click', (e) => {
          const b = e.target.closest('button');
          if (!b) return;
          g.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
          update();
        });
      });
      update();
    };

    document.querySelectorAll('[data-tka-product]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-tka-product]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
